import angular from "angular";
import panel from "../services";

function photoGallery(panel) {
    return {
        restrict: 'E',
        scope: {
          count: '=',
          gallery: '=',
          view: '='
        },
        link: (scope, element) => {
          scope.panel = panel;
          let items = [];
          for (let i in scope.gallery) {
            items.push({src:scope.gallery[i].image, preloaded:true});
          }

          if (scope.view && scope.view === 'grid') {
            $(element).on('click', '.photo-thumb', (e) => {
              let index = $(e.currentTarget).attr('photo-index');
              $.magnificPopup.open({
                items: items,
                gallery: { enabled: true},
                type: 'image'
              }, index--);
            });
          } else {
            $(element).on('click', '.gallery-viewer', (e) => {
              if (parseInt(scope.count) > 0) {
                $.magnificPopup.open({
                  items: items,
                  gallery: {enabled: true},
                  type: 'image'
                });
              }
            });
          }
        },
        template: require ('./templates/photo-gallery.html')
    };
}

export default angular.module('directives.photoGallery', [panel]).directive('photoGallery', photoGallery).name;



// WEBPACK FOOTER //
// ./src/app/directives/photoGallery.js